import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.prototype.$API_ENDPOINT = "https://cloud.schmuckli.net";

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
